<script>

import { SUPPORTED_LOCALES } from '@/utils/locale.js';

export default {
    props: ['user'],
    data() {
        return {
            errors: {},
            loading: false,
            controller: {
                submit: null,
                load: null
            },
            locales: SUPPORTED_LOCALES,
        }
    },
    methods: {
        submit() {
            this.loading = true;
            this.controller.submit = new AbortController();
            let request;
            let data = {
                name: this.user.company?.name,
                nip: this.user?.company?.nip,
                city: this.user?.company?.city,
                address: this.user?.company?.address,
                email: this.user.email,
                locale: this.user.locale ?? null,
            }
            if (this.user.id) {
                request = axios.put('/users/employers/' + this.user.id, data, {
                    signal: this.controller.submit.signal
                })
            } else {
                request = axios.post('/users/employers', data, {
                    signal: this.controller.submit.signal
                })
            }
            request.then((response) => {
                if (this.user.id) {
                    this.$toast.success(this.$t('employers.messages.account_updated'));
                } else {
                    this.$toast.success(this.$t('employers.messages.account_updated'));
                }
                this.$router.push({name: 'employers.index'});
            }).catch((data) => {
                console.log(data);
                this.errors = data.response?.data?.errors || {};
            }).finally(() => {
                this.loading = false;
            })
        }

    },
    beforeUnmount() {
        if (this.controller.submit) {
            this.controller.submit.abort();
        }
    }
}

</script>
<template>
    <div class="employees-create">

        <form @submit.prevent="submit">

            <b-field :label="$t('companies.fields.name.name')"
                     :type="errors.name ? 'is-danger' : null"
                     :message="errors.name ? errors.name[0] : null">
                <b-input required
                         v-model="user.company.name"
                         icon="domain"
                ></b-input>
            </b-field>

            <b-field :label="$t('companies.fields.nip.name')"
                     :type="errors.nip ? 'is-danger' : null"
                     :message="errors.nip ? errors.nip[0] : null">
                <b-input required
                         v-model="user.company.nip"
                         icon="card-account-details-outline"
                ></b-input>
            </b-field>

            <b-field :label="$t('companies.fields.city.name')"
                     :type="errors.city ? 'is-danger' : null"
                     :message="errors.city ? errors.city[0] : null">
                <b-input required
                         v-model="user.company.city"
                         icon="city"
                ></b-input>
            </b-field>

            <b-field :label="$t('companies.fields.address.name')"
                     :type="errors.address ? 'is-danger' : null"
                     :message="errors.address ? errors.address[0] : null">
                <b-input required
                         v-model="user.company.address"
                         icon="map-marker"
                ></b-input>
            </b-field>

            <b-field :label="$t('users.fields.email.name')"
                     custom-class="mb-3"
                     :type="errors.email ? 'is-danger' : null"
                     :message="errors.email ? errors.email[0] : null">
                <b-input required
                         type="email"
                         v-model="user.email"
                         icon="at"
                ></b-input>
            </b-field>

            <b-field :label="$t('users.fields.locale.name')"
                     :type="errors.locale ? 'is-danger' : null"
                     :message="errors.locale ? errors.locale[0] : null">
                <b-select v-model="user.locale" icon="translate" expanded>
                    <option :value="null">—</option>
                    <option v-for="locale in locales" :key="locale" :value="locale">
                        {{ $t('languages.' + locale) }}
                    </option>
                </b-select>
            </b-field>

            <section>
                <div class="buttons">
                    <b-button type="is-primary" native-type="submit" :loading="loading">
                        {{ $t('actions.save') }}
                    </b-button>
                    <b-button @click.prevent="$router.push({name: 'employers.index'})">
                        {{ $t('actions.back') }}
                    </b-button>
                </div>
            </section>

        </form>
    </div>
</template>
